<template>
<common-dialog
  :show.sync="visible"
  :title="'发送资料至邮箱'"
  class="send-mail-dialog"
>
  <div class="send-mail-body">
    <div class="form-item ">
      <div class="form-item-label">邮箱地址</div>
      <div class="form-item-content">
        <el-input placeholder="请输入邮箱地址" :maxlength="50" v-model="email" @input="emailError=false"></el-input>
        <div class="form-item-error" v-if="emailError" >请输入正确的邮箱地址</div>
      </div>
    </div>
  </div>
  <div class="send-mail-footer" slot="footer">
    <div class="tips">请留意来自service@666visa.cn的邮件</div>
    <el-button  class="s-btn btn-blue btn-lg" @click="mailSubmit" :loading="emailLoading">发送</el-button>
  </div>
</common-dialog>
</template>

<script>
import validates from '@/libs/validates';
import sensorsdata from 'sa-sdk-javascript';
import User from '../../../libs/user.js';
import CommonDialog from '../../../components/common/modals/common-dialog/common-dialog.vue';
import Http from '../../../libs/http';

export default {
  components: {
    CommonDialog,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    onJobIdList: {
      type: Array,
    },
    showHeader: { // 是否显示抬头
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      visible: this.show,
      email: '',
      emailError: false,
      emailLoading: false,
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.email = '';
      this.emailError = false;
    },
    mailSubmit() {
      const { emailReg } = validates.inputRegexpCollection;
      if (!emailReg.test(this.email)) {
        return (this.emailError = true);
      }
      this.emailLoading = true;
      let is_show_header;
      // 批量的，进来时空，这样会读取自身存储的，然后单个，会读取当前选择的
      if (this.showHeader !== undefined) {
        is_show_header = this.showHeader ? 1 : 0;
      }
      Http.post('/archives_onjob_email_send', {
        onjob_id_list: this.onJobIdList,
        email: this.email,
        is_show_header,
      }).then(() => {
        sensorsdata.track('On_the_job_send_mailbox', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id,
        });
        this.$message.success('发送成功');
        this.visible = false;
        this.emailLoading = false;
      }).catch(() => {
        this.emailLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.send-mail-dialog{
  /deep/ .el-dialog{
    width: 600px;
  }
  /deep/ .el-input{
    .el-input__inner{
      height: 40px;
    }
  }
  .send-mail-body{
    padding: 24px;
    .form-item{
      display: flex;
      align-items: center;
      .form-item-label{
        flex-shrink: 0;
        width: 84px;
        color: #2F333D;
        font-size: 16px;
        font-weight: 500;
      }
      .form-item-content{
        flex-grow: 1;
        position: relative;
        .form-item-error{
          position: absolute;
          left: 0;
          top: 100%;
          margin-top: 2px;
          color: #FF6464;
          font-size: 12px;
        }
      }
    }
  }
  .send-mail-footer{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tips{
      font-size: 14px;
      color: #91999F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/on-job-send-mail-dialog.vue